export default __webpack_public_path__ + "static/media/can.203ad13a.svg";